import React from "react";

import styles from "./styles.less";

const HoveringBar: React.FC = ({ children }) => (
  <div className={styles.hoveringBar}>{children}</div>
);

export default HoveringBar;
